// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"fb4da1b8","81":"b53e4278","140":"3b8dab7d","150":"62a0d9a5","432":"93779436","462":"3013fd9b","506":"59cc4b9c","556":"2e701e33","636":"2ead6e0d","759":"b6053dfe","797":"726198a6","798":"ae08f6d2","799":"8719ae0f","843":"bdfbe023","848":"f098ce49","970":"e12e7f0c"}[chunkId] + ".chunk.js";
};